<template>
  <div class="exam_practice_student_detail">
    <TitleBar title="学生答题详情" back />
    <div class="header">
      <img :src="student.head_img_url" class="avatar" />

      <div class="info-box">
        <div class="name">{{ _show_student_name(student) }}</div>
        <div class="clazz-name">{{ clazzName }}</div>
      </div>

      <div class="score-info">
        <div class="title">综合评价</div>
        <div class="score">{{ totalScore }}</div>
      </div>
    </div>
    <div class="main">
      <div class="card" v-for="(record, index) in records" :key="index">
        <personal-exam-record-card
          :paper-record="record.max_paper_record"
          :name="record.name"
          :seq="index + 1"
          v-if="record.max_paper_record"
        ></personal-exam-record-card>
        <personal-drill-record-card
          :seq="index + 1"
          :name="record.name"
          :drill-infos="record.drill_records"
          v-else
        ></personal-drill-record-card>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { BasePage, Component, Prop } from 'kuaidong-component'
import { IStudentChallengeRecord } from 'kuaidong-model'
import TitleBar from '@/components/TitleBar.vue'
import { AWinter2023 } from 'kuaidong-api'
import ListPage from '@/components/ListPage.vue'
import TrainingOverviewInfo from '@/views/special-skill/components/TrainingOverviewInfo.vue'
import TrainingClazzStaticInfo from '@/views/special-skill/components/TrainingClazzStaticInfo.vue'
import PersonalDrillRecordCard from './components/PersonalDrillRecordCard.vue'
import PersonalExamRecordCard from './components/PersonalExamRecordCard.vue'

@Component({
  components: {
    TitleBar,
    ListPage,
    TrainingOverviewInfo,
    TrainingClazzStaticInfo,
    PersonalDrillRecordCard,
    PersonalExamRecordCard,
  },
})
export default class PracticeStudentDetailPage extends BasePage {
  @Prop({ type: String, required: true })
  userId!: string

  @Prop({ type: String, required: true })
  chanllengeClassID!: string

  recordDetail: IStudentChallengeRecord | null = null

  get totalScore() {
    return this.recordDetail ? this.recordDetail.score : '-'
  }

  get student() {
    return this.recordDetail ? this.recordDetail.student_vo : null
  }
  get clazzName() {
    return this.recordDetail ? this.recordDetail.class_vo.note_name || this.recordDetail.class_vo.name : '-'
  }

  get records() {
    return this.recordDetail ? this.recordDetail.item_records : []
  }

  async created() {
    this.fetchStudentRecord()
  }

  async fetchStudentRecord() {
    this.recordDetail = await AWinter2023.studentRecord(this.userId, this.chanllengeClassID)
  }
}
</script>
<style lang="less">
.exam_practice_student_detail {
  > .header {
    padding: 24px;
    background: #fff;
    box-shadow: 0px 6px 58px rgba(196, 203, 214, 0.1);
    border-radius: 8px;
    display: flex;
    align-items: center;
    > img {
      width: 64px;
      height: 64px;
      border-radius: 50%;
    }
    > .info-box {
      display: flex;
      flex-direction: column;
      margin: 0 20px;
      > .name {
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        color: #2d2f33;
      }

      > .clazz-name {
        margin-top: 8px;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #9da2a9;
      }
    }

    > .score-info {
      display: flex;
      flex-direction: column;
      flex: 1;
      text-align: right;
      > .title {
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        color: #9da2a9;
      }
      > .score {
        margin-top: 6px;
        font-weight: 700;
        font-size: 32px;
        line-height: 26px;
        color: #2d2f33;
        margin-right: 18px;
      }
    }
  }
  > .main {
    margin-top: 30px;
    padding: 22px 24px;
    background: #fff;
  }
}
</style>
